if (!customElements.get("cart-ext")) {
  class CartExt extends HTMLElement {
    constructor() {
      super();

      this.smartCart = {};
      this.shopifyCart = {};
    }

    connectedCallback() {
      document.addEventListener("rebuy:cart.change", (event) => {
        // console.log("rebuy:cart.change event", event.detail);
        this.smartCart = event.detail;
      });
    }
    disconnectedCallback() {}
  }

  customElements.define("cart-ext", CartExt);
}
